import { DatePipe, NgClass, NgFor, NgIf, NgStyle } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChildren } from "@angular/core";
import { RouterLink } from "@angular/router";
import { Subscription } from "rxjs";
import { KebabCasePipe } from "../../../pipes/kebab-case.pipe";
import { SafeResourceUrlPipe } from "../../../pipes/safeResourceUrl/safe-resource-url.pipe";
import { AnimacionVideoComponent } from "../../animacion-video/animacion-video.component";
import { SkeletonImageComponent } from "../../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-fila-cuatro-columnas",
  templateUrl: "./fila-cuatro-columnas.component.html",
  styleUrls: ["./fila-cuatro-columnas.component.css"],
  imports: [NgClass, NgStyle, RouterLink, AnimacionVideoComponent, DatePipe, KebabCasePipe, SafeResourceUrlPipe, SkeletonImageComponent, NgIf, NgFor],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilaCuatroColumnasComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() noticias = [];
  @Input() descripcion: true;
  @Input() imagen: true;
  @Input() idStart: any;
  @Input() lazy: boolean;
  @Input() size: number;
  @Input() autorEmpresa;
  @Input() showFecha = true;
  nSub: Subscription;

  constructor() {}

  @ViewChildren("nombreAutor") nombres: QueryList<any>;

  ngOnInit(): void {}
  formatDate(obj) {
    if (obj == null) {
      return null;
    }
    return obj.toString().replace(/\s/g, "T");
  }

  ngOnDestroy(): void {
    if (this.nSub) this.nSub.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.comprobarNombres();
  }

  comprobarNombres() {
    //TODO revisar
    this.nSub = this.nombres.changes.subscribe((c) => {
      c.toArray().forEach((nombreElement) => {
        const padre = nombreElement.nativeElement.parentElement;
        const fecha = padre.children[1];
        if (padre.offsetWidth < fecha.offsetWidth + nombreElement.nativeElement.offsetWidth) {
          this.recortaNombre(nombreElement);
        }
      });
    });
  }
  recortaNombre(nombreElement: ElementRef) {
    const nombreCompleto = nombreElement.nativeElement.innerText.trim().split(" ");
    if (nombreCompleto.length > 1) {
      for (let i = 1; i < nombreCompleto.length; i++) {
        nombreCompleto[i] = nombreCompleto[i].charAt(0).toUpperCase() + ".";
      }
      nombreElement.nativeElement.innerText = nombreCompleto.join(" ");
    }
  }

  trackByNoticia(index: number, noticia: any): number {
    return noticia.idVideo;
  }
}
